import { Block } from 'webiq.boilerplate'

export default class DynamicNav extends Block {
	static title = 'nav'

	init() {
		this.navItem = this.getElement('item')

		this.menu = this.getElement('items')
		this.mobileMenu = document.querySelector('.mobile-nav-new__toggle')
		this.menuAccount = this.getElement('item--account')
		this.menuLogin = this.getElement('item--login')

		this.items = Array.from(document.querySelectorAll('.nav__items > li'))

		window.addEventListener('resize', () => this.calculateMenuWidth(), {
			passive: true,
		})
		this.calculateMenuWidth()
	}

	calculateMenuItemsWidth(element) {
		const clientRect = element.getBoundingClientRect()
		return clientRect.width
	}

	calculateMenuWidth() {
		const maxMenuWidth = this.menu.clientWidth

		const menuWidth = this.items.reduce((acc, cur) => this.calculateMenuItemsWidth(cur) + acc, 0)

		if (menuWidth > maxMenuWidth) {
			this.addModifier('mobile')
			this.mobileMenu.classList.add('mobile-nav-new__toggle--active')
		} else {
			this.removeModifier('mobile')
			this.mobileMenu.classList.remove('mobile-nav-new__toggle--active')
		}
	}
}
